module.exports = __webpack_public_path__ + "img/网络互动类.f14dfd4d.png";